import React, { useContext, useEffect, useState } from 'react'
// import { FaArrowLeftLong } from "react-icons/fa6";
// import { FaArrowRight } from "react-icons/fa6";
import { FormContext } from './Provider';
import { useNavigate } from 'react-router-dom';
// import { nav } from 'framer-motion/client';



export default function RegisterInfo({ step, setStep }) {
    const { registerinfo, setRegisterInfo } = useContext(FormContext);


    const api = process.env.REACT_APP_URL;

    const [courses, setCourses] = useState(null)
    // const [enddate, setEndDate] = useState('')

    useEffect(() => {
        fetch(`${api}/get-courses`,
            {
                method: 'GET',
                credentials: 'include'
            })
            .then(res => res.json())
            .then((data) => {
                if (data.success) {
                    setCourses(data.courses)
                    console.log(data)
                }
                else {
                    alert(data.message)
                }

            })

    }, [api])

    //error for form field
    const [registererror, setRegistererror] = useState({
        registrationDate: "",
        courseName: "",
        batchStartDate: "",
        batchEndDate: "",
        hearAboutUs: "",
        feeMethod: "",
        uploadFile: "",

    })

    // error msg code

    const handleChange = async (e) => {
        const { id, value } = e.target;

        // Remove error message for the specific field if the user types
        setRegisterInfo((prev) => ({
            ...prev,
            [id]: value
        }));

        let newStartDate = id === 'batchStartDate' ? value : registerinfo.batchStartDate;
        let newCourseName = id === 'courseName' ? value : registerinfo.courseName;

        if (newStartDate && newCourseName) {
            await generateDate(newStartDate, newCourseName);
        }


        // // Clear error message for the specific field if it is now valid
        setRegistererror((prevErrors) => ({
            ...prevErrors,
            [id]: value ? "" : prevErrors[id], // Reset error message if the field is filled
        }));


    };

    const generateDate = (startDate, courseName) => {
        const selectedCourse = courses.find(c => c.courseTitle === courseName);

        if (startDate && selectedCourse) {
            const start = new Date(startDate);
            start.setMonth(start.getMonth() + parseInt(selectedCourse.months));
            const end = start.toISOString().split("T")[0];

            setRegisterInfo(prev => ({
                ...prev,
                batchEndDate: end
            }));
        }
    };



    // file Vie Images


    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            // Update file in state
            const preview = URL.createObjectURL(file);
            setRegisterInfo((prev) => ({
                ...prev,
                uploadFile: file,
                imagePreviews: preview,
            }));


            setRegistererror((prev) => ({
                ...prev,
                uploadFile: '',
            }));
            // Create object URL for preview

        }
    };
    // Revoke object URL on cleanup
    // useEffect(() => {
    //     return () => {
    //         if (previewURL) {
    //             URL.revokeObjectURL(previewURL);
    //         }
    //     };
    // }, [previewURL]);


    const handleSubmit = (e) => {
        e.preventDefault()
        const newErrors = {}

        if (!registerinfo.registrationDate) {
            newErrors.registrationDate = "Registration Date is required";
        }
        if (!registerinfo.courseName) {
            newErrors.courseName = "Course Name is required";
        }
        if (!registerinfo.batchStartDate) {
            newErrors.batchStartDate = "Batch Start Date is required";
        }
        if (!registerinfo.batchEndDate) {
            newErrors.batchEndDate = "Batch End Date is required";
        }
        if (!registerinfo.hearAboutUs) {
            newErrors.hearAboutUs = "How did you hear about us? is required";
        }
        if (!registerinfo.feeMethod) {
            newErrors.feeMethod = "Payment Method is required";
        }
        if (!registerinfo.uploadFile) {
            newErrors.uploadFile = "File upload is required";
        }


        if (Object.keys(newErrors).length > 0) {
            setRegistererror(newErrors);
        }
        else {
            setRegistererror({});
            navigate('/admission-form');
            setStep(step + 1);
        }
    };


    const navigate = useNavigate();

    return (
        <section className="bg-white rounded-lg shadow-md p-7">

            <div className=' bg-gray-100 px-4 container py-5 h-100 flex justify-center items-start'>
                <div className="bg-white p-6 rounded-lg shadow-md w-full max-w-4xl">
                    <div className="font-bold text-lg text-primary-800">Registration Details</div>
                    <div className="pt-2 text-gray-700">Please provide your Registration information</div>
                    <form onSubmit={handleSubmit}>
                        {/* First and Last Name */}
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6 mt-8">
                            <div className="relative">
                                <input
                                    type="date"
                                    id="registrationDate"
                                    value={registerinfo.registrationDate}
                                    onChange={handleChange}
                                    className="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                                    placeholder=" "
                                    required
                                />
                                <label
                                    htmlFor="registrationDate"
                                    className="absolute text-base font-medium text-gray-500 duration-300 transform -translate-y-5 scale-75 top-2 z-10 origin-[1] bg-white px-2 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-3 "

                                >
                                    Registration Date <span className='text-red-600 text-lg'> *</span>
                                </label>
                                {registererror.registrationDate && (
                                    <p className="text-sm text-red-500 mt-2">{registererror.registrationDate}</p>
                                )}
                            </div>
                            <div className="relative w-full">
                                <select
                                    id="courseName"
                                    onChange={handleChange}
                                    value={registerinfo.courseName}
                                    className="block w-full px-2.5 pb-2.5 pt-4 text-xs sm:text-sm text-gray-900 bg-transparent rounded-lg border-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer truncate"
                                    required
                                >
                                    <option value="" disabled>Select Course</option>
                                    {courses && courses.map(course => (
                                        <option key={course.id} value={course.courseTitle}>{course.courseTitle}</option>
                                    ))}
                                </select>

                                {/* Error */}
                                {registererror.courseName && (
                                    <p className="text-xs text-red-500 mt-2">{registererror.courseName}</p>
                                )}

                                {/* Arrow */}
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="w-4 h-4 text-gray-500 absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none"
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                >
                                    <path
                                        fillRule="evenodd"
                                        d="M5.23 7.79a1 1 0 011.41 0L10 11.12l3.36-3.33a1 1 0 111.42 1.41l-4 4a1 1 0 01-1.42 0l-4-4a1 1 0 010-1.41z"
                                        clipRule="evenodd"
                                    />
                                </svg>

                                {/* Label */}
                                <label
                                    htmlFor="courseName"
                                    className="absolute text-base font-medium text-gray-500 dark:text-gray-500 duration-300 transform -translate-y-5 scale-75 top-2 z-10 origin-[1] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-3"
                                >
                                    Course Name <span className='text-red-600 text-lg'> *</span>
                                </label>
                            </div>



                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6 items-center">
                            <div className="relative">
                                <input
                                    type="date"
                                    id="batchStartDate"
                                    value={registerinfo.batchStartDate}
                                    onChange={handleChange}
                                    className="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                                    placeholder=" "
                                    required
                                />
                                <label
                                    htmlFor="batchStartDate"
                                    className="absolute text-base  text-gray-500 duration-300 transform -translate-y-5 scale-75 top-2 z-10 origin-[1] bg-white px-2 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-3 font-medium"
                                >
                                    Batch Start Date<span className='text-red-600 text-lg'> *</span>
                                </label>
                                {registererror.batchStartDate && (
                                    <p className="text-sm text-red-500 mt-2">{registererror.batchStartDate}</p>
                                )}
                            </div>
                            <div className="relative">
                                <input
                                    type="date"
                                    id="batchEndDate"
                                    value={registerinfo.batchEndDate}
                                    className="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-gray-100 rounded-lg border-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer cursor-not-allowed"
                                    readOnly
                                    disabled
                                />

                                <label
                                    htmlFor="batchEndDate"
                                    className="absolute text-base  text-gray-500 duration-300 transform -translate-y-5 scale-75 top-2 z-10 origin-[1] bg-white px-2 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-3 font-medium"
                                >
                                    Batch End Date <span className='text-red-600 text-lg'> *</span>
                                </label>
                                {registererror.batchEndDate && (
                                    <p className="text-sm text-red-500 mt-2">{registererror.batchEndDate}</p>
                                )}
                            </div>
                        </div>

                        {/* Email and Phone */}
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                            <div className="mb-4">
                                <div className="relative">
                                    <select
                                        id="hearAboutUs"
                                        value={registerinfo.hearAboutUs}
                                        onChange={handleChange}
                                        className="block w-full px-2.5 pb-2.5 pt-4 text-sm text-gray-900 bg-transparent rounded-lg border-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                                        required
                                    >
                                        <option value="" disabled>
                                            Select Option
                                        </option>
                                        <option value="Social Media">Social Media</option>
                                        <option value="Seminar">Seminar</option>
                                        <option value="Friend">Friend</option>
                                        <option value="Ex-Student">Ex-Student</option>
                                        <option value="Others">Others</option>
                                    </select>

                                    {registererror.hearAboutUs && (
                                        <p className="text-sm text-red-500 mt-2">{registererror.hearAboutUs}</p>
                                    )}

                                    {/* Label */}
                                    <label
                                        htmlFor="hearAboutUs"
                                        className="absolute text-base font-medium text-gray-500 duration-300 transform -translate-y-5 scale-75 top-2 z-10 origin-[1] bg-white px-2 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-3"
                                    >
                                        How Did You Hear About Us? <span className='text-red-600 text-lg'> *</span>
                                    </label>

                                    {/* Dropdown icon */}
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="w-4 h-4 text-gray-500 absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                    >
                                        <path
                                            fillRule="evenodd"
                                            d="M5.23 7.79a1 1 0 011.41 0L10 11.12l3.36-3.33a1 1 0 111.42 1.41l-4 4a1 1 0 01-1.42 0l-4-4a1 1 0 010-1.41z"
                                            clipRule="evenodd"
                                        />
                                    </svg>
                                </div>

                                {/* Show this only if "Friend" is selected */}
                                {(registerinfo.hearAboutUs === "Friend" || registerinfo.hearAboutUs === "Others") && (
                                    <div className="mt-4">
                                        <label htmlFor="reasons" className="block text-sm font-medium text-gray-700 mb-1">
                                            Friend's Name / Others
                                        </label>
                                        <input
                                            type="text"
                                            id="reasons"
                                            value={registerinfo.reasons}
                                            onChange={handleChange}
                                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                            placeholder="Enter your friend's name / Others"
                                            required
                                        />
                                    </div>
                                )}
                            </div>

                            {/* Payment Method */}

                            <div className="mb-4">
                                <div className="relative">
                                    <select
                                        id="feeMethod"
                                        value={registerinfo.feeMethod}
                                        onChange={handleChange}
                                        className="block w-full px-2.5 pb-2.5 pt-4 text-sm text-gray-900 bg-transparent rounded-lg border-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                                        required
                                    >
                                        <option value="" disabled>
                                            Select Payment Method
                                        </option>
                                        {/* <option value="Fresh Registration">Fresh Registration</option> */}
                                        <option value="Installment">Installment</option>
                                        <option value="Full Payment">Full Payment</option>
                                        {/* <option value="Upgradation">Upgradation</option> */}
                                    </select>

                                    {registererror.feeMethod && (
                                        <p className="text-sm text-red-500 mt-2">{registererror.feeMethod}</p>
                                    )}
                                    {/* Dropdown arrow icon */}
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="w-4 h-4 text-gray-500 absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                    >
                                        <path
                                            fillRule="evenodd"
                                            d="M5.23 7.79a1 1 0 011.41 0L10 11.12l3.36-3.33a1 1 0 111.42 1.41l-4 4a1 1 0 01-1.42 0l-4-4a1 1 0 010-1.41z"
                                            clipRule="evenodd"
                                        />
                                    </svg>
                                    <label htmlFor="floating_outlined" className="absolute text-base font-medium text-gray-500 dark:text-gray-500 duration-300 transform -translate-y-5 scale-75 top-2 z-10 origin-[1] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-3"> Fee Method
                                        <span className='text-red-600 text-lg'> *</span></label>
                                </div>

                            </div>
                        </div>

                        {/* Subject Select */}
                        <label className='font-medium mb-3'>Upload Signature:<span className='text-red-600 text-lg'> *</span></label>
                        <div className="flex items-center justify-center w-full">
                            <label
                                htmlFor="dropzone-fileee"
                                className={`flex flex-col items-center justify-center w-full h-44 cursor-pointer ${!registerinfo.imagePreviews ? 'border-2 border-dashed border-gray-300 rounded-lg bg-gray-50 hover:bg-gray-100 transition duration-200' : ''} `}
                            >
                                {/* 👇 Conditional Preview or Default SVG Instructions */}
                                {registerinfo.imagePreviews ? (
                                    <div className="flex items-center justify-start w-full h-full  ">
                                        <img
                                            src={registerinfo.imagePreviews}
                                            alt="Preview"
                                            className="h-full object-contain  border-2 border-gray-300 border-dashed rounded-lg"
                                        />
                                    </div>
                                ) : (
                                    <div className="flex flex-col items-center justify-center pt-5 pb-6 ">
                                        <svg
                                            className="w-8 h-8 mb-4 text-gray-500"
                                            aria-hidden="true"
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="none"
                                            viewBox="0 0 20 16"
                                        >
                                            <path
                                                stroke="currentColor"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth="2"
                                                d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5
                5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5
                5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                                            />
                                        </svg>
                                        <p className="mb-2 text-sm text-gray-500">
                                            <span className="font-semibold">Click to upload</span> or drag and drop
                                        </p>
                                        <p className="text-xs text-gray-500">SVG, PNG, JPG or GIF (MAX. 500x400px)</p>
                                    </div>
                                )}

                                <input
                                    id="dropzone-fileee"
                                    type="file"
                                    className="hidden"
                                    onChange={handleFileChange}
                                    required
                                />
                            </label>
                        </div>

                        {registererror.uploadFile && (
                            <p className="text-sm text-red-500 mt-2">{registererror.uploadFile}</p>
                        )}

                        {/* Submit Button */}
                        <div className="flex flex-row sm:flex-row justify-between items-stretch sm:items-center gap-4 mt-6">
                            {/* Previous Button */}
                            <div className="w-full sm:w-auto">
                                <button
                                    type="button"
                                    className="w-full  px-6 py-2 flex items-center justify-center bg-primary-800 hover:bg-primary-700 text-white text-base font-medium rounded-lg  transition"
                                    onClick={() => {
                                        navigate('/admission-form')
                                        setStep(step - 1)
                                    }} >
                                    {/* <FaArrowLeftLong className="mx-2" />  */}
                                    Back
                                </button>
                            </div>

                            {/* Next Button */}
                            <div className="w-full sm:w-auto">
                                <button
                                    type="submit"
                                    onClick={handleSubmit}
                                    className="w-full  px-6 py-2 flex items-center justify-center bg-primary-800 hover:bg-primary-700 text-white text-base font-medium rounded-lg transition"
                                >
                                    Next
                                    {/* <FaArrowRight className="ms-3" /> */}
                                </button>
                            </div>
                        </div>

                    </form>
                </div>
            </div>
        </section>
    );
}